import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	async getCommCodes(codeType) {
		//console.log('codeType', codeType);
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getMkObjList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		let causPartNo;
		let srchMm01 = searchParams.srchMm01;
		var strtMm01, endMm01
		if (searchParams.strtMm01) {
			strtMm01 = moment(searchParams.strtMm01).format('YYYYMMDD');
		} else {
			strtMm01 = '';
		}
		if (searchParams.endMm01) {
			endMm01 = moment(searchParams.endMm01).format('YYYYMMDD');
		} else {
			endMm01 = '';
		}
		
		/*특수문자가 있는것들은 다음과 같이해줘됨 */
		if (searchParams.causPartNo) {
			causPartNo = encodeURIComponent(searchParams.causPartNo);
		} else {
			causPartNo = '';
		}

		queryStr = objectToQuerystring({
			dlrCpnyCd: searchParams.dlrCpnyCd /*딜러점*/,
			roNo: searchParams.roNo /*RO번호*/,
			clmNo: searchParams.clmNo /*클래임번호*/,
			causPartNo: causPartNo /*품번*/,
			dlvgNm: searchParams.dlvgNm /*실납품사*/,
			ctype: searchParams.ctype /*클레임타입*/,
			prcStepGb: searchParams.prcStepGb /*처리단계*/,
			prcRsltCd: searchParams.prcRsltCd /*처리결과*/,
			mkobjCd:searchParams.mkobjCd,
			strtMm01:strtMm01,
			endMm01:endMm01,
			startDcsnDd: searchParams.startDcsnDd, //변제확정일자from
			endDcsnDd: searchParams.endDcsnDd, //변제확정일자to
			startAplcDdObj: searchParams.startAplcDdObj, //이의제기일from
			endAplcDdObj: searchParams.endAplcDdObj, //이의제기일to
			startDcsnDdObj: searchParams.startDcsnDdObj, //이의처리 완료일from
			endDcsnDdObj: searchParams.endDcsnDdObj, //이의처리 완료일to
			currentPage,
			pageUnit
		});

		//console.log('queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/qlty/mkObj/v1/mkObjs` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},

	getClamNoPopList(paramClamNo) {
		return client
			.get(`${BASE_URL}/mqy/qlty/mkObj/v1/clmNo/${paramClamNo}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	saveMkObjPopup: ({ formData }) => {
		let url = `${BASE_URL}/mqy/qlty/mkObj/v1/status/1/`;

		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	fileDownload: ({ params }) => {
		// console.log('params', params);
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downloadFiles`, params, { responseType: 'blob' })
				.then(response => {
					resolve(response);
				})
				.catch(error => reject(new Error(error.message || error.response)));
		});
	},
	saveStateAppr: ({ saveMkObjMst }) => {
		let queryStr = '';

		queryStr = objectToQuerystring({
			aplCpnyCd: saveMkObjMst.aplCpnyCd /*확정협력사코드*/,
			aplDvswRt1: saveMkObjMst.aplDvswRt1 /*확정 협력사 분담율/귀책율*/,
			aplDvswRt2: saveMkObjMst.aplDvswRt2 /*확정 협력사 적용 분담율/귀책율*/,
			aplRpymAmt1: saveMkObjMst.aplRpymAmt1 /*확정 협력사 변제금액*/,
			aplRpymAmt2: saveMkObjMst.aplRpymAmt2 /*확정 협력사 적용 변제금액*/,
			aplCausPartNo: saveMkObjMst.aplCausPartNo /*확정 협력사 품번*/,

			bflCpnyCd: saveMkObjMst.bflCpnyCd /*협력사코드*/,
			bflDvswRt1: saveMkObjMst.bflDvswRt1 /*협력사 분담율/귀책율*/,
			bflDvswRt2: saveMkObjMst.bflDvswRt2 /*협력사 적용 분담율/귀책율*/,
			bflRpymAmt1: saveMkObjMst.bflRpymAmt1 /*협력사 변제금액*/,
			bflRpymAmt2: saveMkObjMst.bflRpymAmt2 /*협력사 적용 변제금액*/,
			causPartNo: saveMkObjMst.causPartNo /*협력사 적용 원인부품번호 RO기초정보에 있는거*/
		});

		//console.log('승인전 파라미터>>', queryStr);

		return client
			.post(
				`${BASE_URL}/mqy/qlty/mkObj/v1/status/2/clmNo/${saveMkObjMst.clmNo}/nos/${saveMkObjMst.nos}/mkobType/${saveMkObjMst.mkobType}/apprA` +
					queryStr
			)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCalAplRpymAmt(param) {
		let queryStr = '';

		queryStr = objectToQuerystring({
			cmpnNo: param.cmpnNo /*캠페인번호*/,
			rtsh: param.rtsh /*적용변제율disPlayGb*/,
			disPlayGb: param.disPlayGb
		});

		return client

			.get(`${BASE_URL}/mqy/qlty/clamMst/v1/roNo/${param.roNo}/cpnyCd/${param.cpnyCd}/causPartNo/${param.causPartNo}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
